import React from 'react'
import { styled } from '@creditas-ui/react'

const Iframe = styled.iframe`
  height: 100%;
  width: 100%;
`
const Dashboard = ({ path }) => (
  <Iframe src={path} title="Dashboard de Performance" />
)

export { Dashboard }
